import { render, staticRenderFns } from "./EnableMessageSwitch.vue?vue&type=template&id=15ddf1a4&"
import script from "./EnableMessageSwitch.vue?vue&type=script&lang=js&"
export * from "./EnableMessageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports